import { formatMoney } from "@faire/web/common/money";
import React from "react";

import { ProductTileInfo } from "@faire/retailer/features/MarketplaceItems/ProductTile";
import { showProductPromotions } from "@faire/retailer/lib/showProductPromotions";
import {
  PRICE_TEXT_SURFACE,
  Price,
} from "@faire/retailer/views/product/ProductDetails/Price";

interface IPriceTextProps {
  productTile?: Pick<
    ProductTileInfo,
    | "is_locked_view"
    | "min_option_wholesale_promo_price"
    | "min_option_wholesale_price"
    | "min_option_retail_price"
  >;
}

export const PriceText: React.FC<IPriceTextProps> = ({ productTile }) => {
  if (!productTile) {
    return null;
  }
  const productLevelPromotion = !productTile?.is_locked_view
    ? productTile?.min_option_wholesale_promo_price
    : undefined;
  const originalPrice = productTile?.min_option_wholesale_price
    ? formatMoney({
        money: productTile.min_option_wholesale_price,
        omitCentsIfZero: true,
      })
    : "";

  const wholesalePrice = productTile?.min_option_wholesale_promo_price
    ?.discounted_item_price
    ? formatMoney({
        money:
          productTile.min_option_wholesale_promo_price.discounted_item_price,
        omitCentsIfZero: true,
      })
    : originalPrice;

  const retailPrice = productTile?.min_option_retail_price
    ? formatMoney({
        money: productTile.min_option_retail_price,
        omitCentsIfZero: true,
      })
    : "";

  return (
    <Price
      showProductPromotions={showProductPromotions(productLevelPromotion)}
      originalPrice={originalPrice}
      wholesalePrice={wholesalePrice}
      retailPrice={retailPrice}
      small
      isTilePricing
      priceTextSurface={PRICE_TEXT_SURFACE.PRODUCT_TILE}
    />
  );
};
